import request from '../../utils/request'
//获取办事处分类
export function getRegionalList(query) {
  return request({
    url: '/office/regionalList',
    method: 'get',
    params: query
  })
}
//获取办事处列表
export function getOfficeList(query) {
  return request({
    url: '/office/officeList',
    method: 'get',
    params: query
  })
}
//获取加入我们
export function getJoin(query) {
  return request({
    url: '/office/join',
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/assets/api/contact.js